export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-gradient-to-br from-gray-50 via-white to-brand-50/30 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] bg-brand-100/40 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-[600px] h-[600px] bg-warm-100/30 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-brand-100 text-brand-700 rounded-full text-sm font-medium mb-5 whitespace-nowrap">
              每日更新 · 免费高清
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight tracking-tight">
              90影视 · 免费在线观看
              <br />
              <span className="text-brand-600">高清全集不缓冲</span>
            </h1>

            <p className="text-base md:text-lg text-gray-500 mt-2 mb-6 font-medium">
              海量片库，想看就看，不花一分钱
            </p>

            <p className="text-sm md:text-base text-gray-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              90影视汇聚海量电影、电视剧、综艺、动漫资源，高清画质流畅播放，全程无广告不缓冲。
              最新热剧每日同步更新，经典老片随时回顾，覆盖华语、日韩、欧美等多元内容，
              无论你偏爱悬疑烧脑、甜蜜爱情还是爆笑喜剧，这里都能找到心头好。
              告别付费会员，省钱追剧尽在90影视。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                <span>日更资源 200+</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-movie-2-line text-brand-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span>片库总量 30000+</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-shield-check-line text-green-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span>纯净无广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => handleScroll(e, '#media')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-brand-600 text-white font-semibold rounded-full hover:bg-brand-700 transition-all duration-200 shadow-lg shadow-brand-200 hover:shadow-brand-300 hover:-translate-y-0.5 cursor-pointer no-underline whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line text-lg w-5 h-5 flex items-center justify-center"></i>
                开始观影
              </a>
              <a
                href="#features"
                onClick={(e) => handleScroll(e, '#features')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-gray-700 font-semibold rounded-full border-2 border-gray-200 hover:border-brand-300 hover:text-brand-600 transition-all duration-200 cursor-pointer no-underline whitespace-nowrap text-sm"
              >
                了解更多
                <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-gray-100 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Epic%20cinematic%20collage%20featuring%20diverse%20movie%20and%20TV%20show%20scenes%20including%20ancient%20Chinese%20drama%20costume%20characters%2C%20sci-fi%20space%20scenes%20with%20spaceships%2C%20modern%20variety%20show%20stage%20with%20colorful%20lights%2C%20anime%20style%20characters%20in%20action%20poses%2C%20all%20artistically%20blended%20in%20warm%20cinematic%20tones%20with%20film%20grain%20texture%20and%20dramatic%20lighting%2C%20entertainment%20poster%20style%20composition%2C%20rich%20colors%2C%20professional%20movie%20poster%20aesthetic&width=800&height=600&seq=hero-main-visual-01&orientation=landscape"
                  alt="90影视 - 电影电视剧综艺动漫精彩合集"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-white rounded-xl shadow-lg px-4 py-2.5 flex items-center gap-2">
                <i className="ri-star-fill text-warm-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm font-semibold text-gray-800 whitespace-nowrap">4.9 用户好评</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}